import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  HeaderListComponent,
  PageListComponent,
  ListComponent,
  DatePickerComponent,
} from "../../../common/component/Index";
import Wrapper from "../../../common/component/Wrapper";
import Button from "../../../common/component/Button";
import {
  columnsTable,
  getDataSource,
  getTitleTable,
  capitalizeFirstLetter,
  genaratePaginateFilterSort,
  getPermissionActions
} from "../../../../../helpers/functions";
import DEFINE, { DATE_TIME_FORMAT } from "../../../../../constants/Define";
import { omit } from "lodash";
import "./BtbOrderReport.less";
import moment from 'moment';
import { Link } from "react-router-dom";
import Input from "containers/backend/common/component/Input";


const ReportListCols = [ "hotelName", "fullname", "email", "phoneNumber", "transactionDate", "arrivalDate", "departureDate", "stayNight", "villaOwnerCode", "itineraryNumber", "roomConfirmationNumber", "roomTypeName", "ratePlanCode", "fullnameCustomer", "total" ];

const BtbOrderReport = (props) => {
  const { getBtbOrderReport, btbOrderState, loadingBtbOrder, t, getExportBtbOrderReport, isFetchingExportBtbOrder } = props;
  const permisionActions = useMemo(() => getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.BTB_ORDER_REPORT), []);
  const titleItemTable = useMemo(() => getTitleTable(ReportListCols, [], []),[]);
  const componentTable = useMemo(
    () => ({
      hotelName: {
        key: "hotelName",
        width: 200,
        sorter: (i, k) => i.hotelName - k.hotelName,
      },
      fullname: {
        key: "fullname",
        width: 200,
        sorter: (i, k) => i.fullname - k.fullname,
      },
      email: {
        key: "email",
        width: 200,
        render: ((email) => {
          return <Link to={`#`} className={`mr-2 colorPrimary`}>{email}
          </Link>
        }),
        sorter: (i, k) => i.email - k.email,
      },
      phoneNumber: {
        key: "phoneNumber",
        width: 200,
        sorter: (i, k) => i.phoneNumber - k.phoneNumber,
      },
      transactionDate: {
        key: "transactionDate",
        width: 200,
        sorter: (i, k) => i.transactionDate - k.transactionDate,
        render: (transactionDate) => moment(transactionDate).format(DATE_TIME_FORMAT.DATE_TIME)
      },
      arrivalDate: {
        key: "arrivalDate",
        width: 200,
        sorter: (i, k) => i.arrivalDate - k.arrivalDate,
        render: (arrivalDate) => moment(arrivalDate).format(DATE_TIME_FORMAT.SHORT_DATE)
      },
      departureDate: {
        key: "departureDate",
        width: 200,
        sorter: (i, k) => i.departureDate - k.departureDate,
        render: (departureDate) => moment(departureDate).format(DATE_TIME_FORMAT.SHORT_DATE)
      },
      stayNight: {
        key: "stayNight",
        width: 200,
      },
      villaOwnerCode: {
        key: "villaOwnerCode",
        width: 200,
        sorter: (i, k) => i.villaOwnerCode - k.villaOwnerCode,
      },
      itineraryNumber: {
        key: "itineraryNumber",
        width: 200,
        sorter: (i, k) => i.itineraryNumber - k.itineraryNumber,
      },
      roomConfirmationNumber: {
        key: "roomConfirmationNumber",
        width: 200,
        sorter: (i, k) => i.roomConfirmationNumber - k.roomConfirmationNumber,
      },
      roomTypeName: {
        key: "roomTypeName",
        width: 200,
      },
      ratePlanCode: {
        key: "ratePlanCode",
        width: 200,
      },
      fullnameCustomer: {
        key: "fullnameCustomer",
        width: 200,
      },
      total: {
        key: "total",
        width: 200,
      },
    }),
    []
  );

  const [filter, setFilter] = useState({});
  const filterBtbOrderReport = (filters) => {
    if (!filters) {
      filters = omit(btbOrderState, ["items", "totalCount", "totalPage"]);
    }
    setFilter(filters);
    getBtbOrderReport(filters);
  };

  const onExportExcel = () => {
    getExportBtbOrderReport(filter);
  };

  useEffect(() => {
    filterBtbOrderReport();
  }, []);

  const onTableChange = (pagination, filters, sorter) => {
    let newFilter = genaratePaginateFilterSort(pagination, filters, sorter);
    newFilter.bookingStartDate = filter.bookingStartDate;
    newFilter.bookingEndDate = filter.bookingEndDate;
    newFilter.arrivalStartDate = filter.arrivalStartDate;
    newFilter.arrivalEndDate = filter.arrivalEndDate;

    newFilter.email = filter.email;
    newFilter.villaOwnerCode = filter.villaOwnerCode;
    newFilter.itineraryNumber = filter.itineraryNumber;
    newFilter.roomConfirmationNumber = filter.roomConfirmationNumber;

    if(filter.pageSize !== pagination.pageSize){
      newFilter.pageIndex = 1;
    }
    filterBtbOrderReport(newFilter)
  };
  const debounceTimeout = useRef(null);
  const [bookingDate, setBookingDate] = useState([]);
  const [arrivalDate, setArrivalDate] = useState([]);

  const onSelectCreateDateRange = (data) => {
    const newFilter = { ...filter, pageIndex: 1 };
    if(typeof(data.fullValue[0]) !== 'undefined' && typeof(data.fullValue[1]) !== 'undefined' ){
      newFilter.bookingStartDate =  moment(data.fullValue[0]).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT);
      newFilter.bookingEndDate = moment(data.fullValue[1]).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT);
    }else{
      delete newFilter.bookingStartDate;
      delete newFilter.bookingEndDate;
    }
    setBookingDate([data.fullValue[0], data.fullValue[1]]);
    filterBtbOrderReport(newFilter);
  };
  const onSelectArrivalDateRange = (data) => {
    const newFilter = { ...filter, pageIndex: 1 };
    if(typeof(data.fullValue[0]) !== 'undefined' && typeof(data.fullValue[1]) !== 'undefined' ){
      newFilter.arrivalStartDate =  moment(data.fullValue[0]).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT);
      newFilter.arrivalEndDate = moment(data.fullValue[1]).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT);
    }else{
      delete newFilter.arrivalStartDate;
      delete newFilter.arrivalEndDate;
    }
    setArrivalDate([data.fullValue[0], data.fullValue[1]]);
    filterBtbOrderReport(newFilter);
  };

  const [email, setEmail] = useState("");
  const [villaOwnerCode, setVillaOwnerCode] = useState("");
  const [itinerary, setItinerary] = useState("");
  const [roomConfirm, setRoomConfirm] = useState("");
  const handleOnChange = (stateSetter, filterKey, value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    stateSetter(value);
    const newFilter = { ...filter };
    newFilter.pageIndex = 1;
    newFilter[filterKey] = (value === "" || value === null) ? undefined : value;
    if (newFilter[filterKey] === undefined) delete newFilter[filterKey];
    debounceTimeout.current = setTimeout(() => {
      filterBtbOrderReport(newFilter);
    }, 500);
  };
  const onchangeEmail = (value) => {
    handleOnChange(setEmail, 'email', value);
  };
  const onchangeVillaOwnerCode = (value) => {
    handleOnChange(setVillaOwnerCode, 'villaOwnerCode', value);
  };
  const onchangeItineraryNumber = (value) => {
    handleOnChange(setItinerary, 'itineraryNumber', value);
  };
  const onchangeRoomConfirmationNumber = (value) => {
    handleOnChange(setRoomConfirm, 'roomConfirmationNumber', value);
  };

  const CustomButton = ({ onPress = () => {}, title = "", disabled = false, loading = false }) => {
    return (
      <Button
        type="primary"
        onClick={onPress}
        icon="download"
        loading={loading}
        disabled={!btbOrderState?.items || disabled}
        className="mr-2 height-btn"
      >
        {title}
      </Button>
    );
  };

  return (
    <Wrapper className="col-md-12 p-0 mt-3 report-list">
      <PageListComponent className="cash-flow-detail-page">
        <HeaderListComponent
          path={props.match.path}
          groupPath={"cashFlow"}
          titleHeader={capitalizeFirstLetter(
            `${t("item.btbOrderReport.title")}`
          )}
        />
        {
          permisionActions.allowView && 
          <>
            <Wrapper className={`d-flex row`}>
              <Wrapper className="col-12">
                <div className="d-flex justify-content-end mb-3">
                  <CustomButton
                    onPress={onExportExcel}
                    title={t(`item.btbOrderReport.export`)}
                    loading={isFetchingExportBtbOrder}
                    className="btn btn-primary"
                    disabled={!permisionActions.allowExportFileExcel}
                  />
                </div>
                <div className="table-responsive">
                  <table className="table w-75">
                    <tbody>
                      <tr>
                        <td className="pl-1 pr-1 text-right" style={{ width: '15%'}}>
                          <label className="font-weight-bold mt-3">{t(`item.btbOrderReport.transactionDate`)}</label>
                        </td>
                        <td className="pl-1 pr-1">
                          <DatePickerComponent
                            className={`form-control applyDates`}
                            hmsComponent={`RangePicker`}
                            format={DATE_TIME_FORMAT.SHORT_DATE}
                            onChange={onSelectCreateDateRange}
                            name={`applyDates`}
                            placeholder={[t("placeHolderForm.startDate"), t("placeHolderForm.endDate")]}
                            value={bookingDate}
                          />
                        </td>
                        <td className="pl-1 pr-1 text-right" style={{ width: '15%'}}>
                          <label className="font-weight-bold mt-3">{t(`item.btbOrderReport.titleArrivalDate`)}</label>
                        </td>
                        <td className="pl-1 pr-1">
                          <DatePickerComponent
                            className={`form-control applyDates`}
                            hmsComponent={`RangePicker`}
                            format={DATE_TIME_FORMAT.SHORT_DATE}
                            onChange={onSelectArrivalDateRange}
                            name={`applyDates`}
                            placeholder={[t("placeHolderForm.startDate"), t("placeHolderForm.endDate")]}
                            value={arrivalDate}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="pl-1 pr-1 text-right">
                          <label className="font-weight-bold mt-2">{t(`item.btbOrderReport.email`)}</label>
                        </td>
                        <td className="pl-1 pr-1">
                          <Input
                            type="text"
                            value={email}
                            className="form-control"
                            onChange={(e) => {onchangeEmail(e.target.value)}}
                          />
                        </td>
                        <td className="pl-1 pr-1 text-right">
                          <label className="font-weight-bold mt-2">{t(`item.btbOrderReport.villaOwnerCode`)}</label>
                        </td>
                        <td className="pl-1 pr-1">
                          <Input
                            type="text"
                            value={villaOwnerCode}
                            className="form-control"
                            onChange={(e) => {onchangeVillaOwnerCode(e.target.value)}}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="pl-1 pr-1 text-right">
                          <label className="font-weight-bold mt-2">{t(`item.btbOrderReport.itineraryNumber`)}</label>
                        </td>
                        <td className="pl-1 pr-1">
                          <Input
                            type="text"
                            value={itinerary}
                            className="form-control"
                            onChange={(e) => {onchangeItineraryNumber(e.target.value)}}
                          />
                        </td>
                        <td className="pl-1 pr-1 text-right">
                          <label className="font-weight-bold mt-2">{t(`item.btbOrderReport.roomConfirmationNumber`)}</label>
                        </td>
                        <td className="pl-1 pr-1">
                          <Input
                            type="text"
                            value={roomConfirm}
                            className="form-control"
                            onChange={(e) => {onchangeRoomConfirmationNumber(e.target.value)}}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Wrapper>
            </Wrapper>
            <Wrapper className={`mt-3`}>
              <ListComponent
                className="cash-flow-report"
                tableKey="sale-report-list"
                classParent="m-0 p-0"
                marginTop={"0"}
                marginBottom={"0"}
                // scroll={{ x: 4200 }}
                scroll={{ x: 'max-content' }}
                tableLayout='auto'
                loading={{ spinning: loadingBtbOrder, size: "large" }}
                rowKey={(record, k) => record.id}
                dataSource={getDataSource(
                  btbOrderState?.items || [],
                  ReportListCols
                )}
                columns={columnsTable({
                  titleTable: titleItemTable,
                  component: componentTable,
                  itemName: "btbOrderReport",
                })}
                pagination={{
                  total: btbOrderState.totalCount,
                  totalPage: btbOrderState.totalPage,
                  current: filter.pageIndex,
                  pageSize: filter.pageSize,
                }}
                onChange={onTableChange}
                componentTableList={{}}
              />
            </Wrapper>
          </>
        }
      </PageListComponent>
    </Wrapper>
  );
};

export default BtbOrderReport;